import { useEffect, useState } from 'react';
import { applyStoredAuthorizationHeader } from '../api/client';

// Debug-Diagnostik fuer den Verbindungsfehler-Screen (Debug-Builds):
// zeigt den echten Auth-Fehler + fuehrt Netzwerk-Probes aus, damit ein
// Screenshot vom Geraet die Ursache eindeutig macht. Bewusst ohne i18n —
// das ist Entwickler-Telemetrie, kein User-Text.
const API_BASE = (import.meta.env.VITE_API_BASE) ?? '';

export interface ProbeResult {
  label: string;
  outcome: string;
}

interface DiagnosticProbeOptions {
  includeStoredBearer?: boolean;
}

export function describeDiagnosticError(error: unknown): string {
  if (error == null) return '(kein Fehlerobjekt)';
  if (error instanceof Error) {
    const status = (error as { status?: number }).status;
    return `${error.name}: ${error.message}${status ? ` [HTTP ${status}]` : ''}`;
  }
  return String(error);
}

export async function runDiagnosticProbe(
  label: string,
  url: string,
  init: RequestInit,
  options: DiagnosticProbeOptions = {},
): Promise<ProbeResult> {
  try {
    const headers = new Headers(init.headers);
    if (options.includeStoredBearer) await applyStoredAuthorizationHeader(headers);
    const res = await fetch(url, { ...init, headers });
    return { label, outcome: `HTTP ${res.status}` };
  } catch (e) {
    return { label, outcome: describeDiagnosticError(e) };
  }
}

export function AuthDiagnostics({ error }: { error: unknown }) {
  const [probes, setProbes] = useState<ProbeResult[]>([]);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const results = [
        await runDiagnosticProbe('stats ohne credentials', `${API_BASE}/api/public/stats`, {}),
        await runDiagnosticProbe('stats mit credentials', `${API_BASE}/api/public/stats`, { credentials: 'include' }),
        await runDiagnosticProbe('auth/me mit credentials', `${API_BASE}/api/auth/me`, { credentials: 'include' }, {
          includeStoredBearer: true,
        }),
      ];
      if (!cancelled) setProbes(results);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      style={{
        fontSize: '11px',
        lineHeight: 1.5,
        opacity: 0.75,
        maxWidth: '320px',
        textAlign: 'left',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
      }}
    >
      <div>API_BASE: {API_BASE || '(leer!)'}</div>
      <div>Fehler: {describeDiagnosticError(error)}</div>
      {probes.length === 0 ? <div>Probes laufen…</div> : probes.map((p) => (
        <div key={p.label}>{p.label}: {p.outcome}</div>
      ))}
    </div>
  );
}
